exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-02f988e9]:export{navy:#001d38;turquoiseBlue:#00adbc;white:#fff;black:#000;error:#b71c1c;cancel:#f75b4a;success:#7ed321}.time-left[data-v-02f988e9]{background-color:#001d38;width:100%;height:-webkit-fit-content;height:-moz-fit-content;height:fit-content;border-radius:15px;padding:1rem}.time-left p[data-v-02f988e9]{color:#fff;margin-left:1rem;font-size:16px}", ""]);

// exports
